import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

export default function Waiting() {
  return (
    <div className="muvika-waiting">
      <CircularProgress />
    </div>
  );
}